export default __webpack_public_path__ + "trouble-with-sleep.webp";